import { ERROR_MESSAGES_DA } from "@/api/cle-api/errors";
import { useCleApiError } from "@/hooks/cle-hooks/useCleApiError";

interface CleApiErrorTextProps {
  error: unknown;
  fallback?: string;
  className?: string;
  as?: "p" | "div" | "span";
}

export const CleApiErrorText = ({
  error,
  fallback = ERROR_MESSAGES_DA.INTERNAL_ERROR,
  className = "text-danger",
  as: Component = "div",
}: CleApiErrorTextProps) => {
  const { userMessage } = useCleApiError(error, fallback);

  return <Component className={className}>{userMessage}</Component>;
};
